import useSocketReconnect from '../../../utils/useSocketReconnect';
import { useEffect, useMemo, useState } from "react";
import moment from 'moment';
import { COLLA } from "../../../utils/utils";
import {
    findEventById,
    getNextTargetActuacio,
    getTargetChooserEvents,
    isModelEventId,
    isTargetEventValid,
    sortEventsByStart,
} from "./targetChooserEvents";

function TargetChooser({ socket, selectedEvent, targetEvent, setTargetEvent, targetAssistencies }) {
    useSocketReconnect(socket, () => {
        socket.emit('.request_all_events');
    });

    const [events, setEvents] = useState([]);
    const isModel = isModelEventId(selectedEvent);
    const title = isModel
        ? "Pinta segons l'assistència d'un esdeveniment"
        : "Comparar assistència amb un altre esdeveniment";
    const showTargetSummary = targetEvent && targetAssistencies && targetAssistencies.length > 0;

    useEffect(() => {
        socket.emit('.request_all_events');
        const handleEvents = (events) => {
            setEvents(sortEventsByStart(events));
        };
        socket.on('.events', handleEvents);
        return () => socket.off('.events', handleEvents);
    }, [socket]);

    const handleEventChange = (e) => {
        setTargetEvent(e.target.value);
    };

    const resetSelection = () => {
        setTargetEvent('');
    };

    const selectedEventInfo = useMemo(
        () => findEventById(events, selectedEvent),
        [events, selectedEvent]
    );

    const targetEvents = useMemo(
        () => getTargetChooserEvents(events, selectedEvent),
        [events, selectedEvent]
    );

    useEffect(() => {
        if (COLLA !== 'xoriguers') return;
        if (isModel) return;
        if (!selectedEventInfo) return;
        if (selectedEventInfo.tipus !== 'assaig') return;

        const now = moment();
        const currentTarget = findEventById(targetEvents, targetEvent);
        if (isTargetEventValid(currentTarget, now)) return;

        const nextActuacio = getNextTargetActuacio(targetEvents, now);
        if (nextActuacio && String(nextActuacio.id) !== String(targetEvent || '')) {
            setTargetEvent(String(nextActuacio.id));
        }
    }, [isModel, selectedEventInfo, targetEvents, targetEvent, setTargetEvent]);

    return (
        <div
            style={{
                padding: '10px',
                backgroundColor: '#eee',
                marginBottom: 10,
            }}
        >
            <h3>{title}</h3>
            <div className="target-chooser" style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                margin: '10px 0'
            }}>
                <select
                    onChange={handleEventChange}
                    value={targetEvent || ''}
                    style={{
                        width: '80%',
                        padding: '5px',
                        fontSize: '16px',
                        borderRadius: '5px',
                    }}
                    >
                    <option value="">Selecciona un esdeveniment...</option>
                    {targetEvents.map(event =>
                        <option key={event.id} value={event.id}>
                            {event.title} - {moment(event["data-esperada-inici"]).format('LLLL')}
                        </option>
                    )}
                </select>
                <button style={{
                    marginLeft: '10px',
                    padding: '5px 10px',
                    fontSize: '16px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                }} onClick={resetSelection}>
                    Borra
                </button>
            </div>

            {
                showTargetSummary &&
                <div style={{
                    marginTop: '10px',
                    padding: '10px',
                    backgroundColor: '#ddd',
                    borderRadius: '5px',
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    display: 'flex',
                }}>
                    <div>&#9989; {targetAssistencies.filter(el => el.assistencia === 'Vinc').length}</div>
                    <div>&#10060; {targetAssistencies.filter(el => el.assistencia === 'No vinc').length}</div>
                    <div>😶 {targetAssistencies.filter(el => el.assistencia === 'No confirmat').length}</div>
                </div>
            }
        </div>
    );
}

export default TargetChooser;
